import Airport from "./icons/Airport";
import ArrowBoxDown from "./icons/ArrowBoxDown";
import ArrowDown from "./icons/ArrowDown";
import ArrowRight from "./icons/ArrowRight";
import ArrowRightDown from "./icons/ArrowRightDown";
import Attraction from "./icons/Attraction";
import Bag from "./icons/Bag";
import Bill from "./icons/Bill";
import Checkmark from "./icons/Checkmark";
import Calendar from "./icons/Calendar";
import Clock from "./icons/Clock";
import ClockLight from "./icons/ClockLight";
import Contact from "./icons/Contact";
import Cruise from "./icons/Cruise";
import Food from "./icons/Food";
import Globe from "./icons/Globe";
import Grid from "./icons/Grid";
import Health from "./icons/Health";
import Hotel from "./icons/Hotel";
import House from "./icons/House";
import Info from "./icons/Info";
import LocationMarker from "./icons/LocationMarker";
import Nature from "./icons/Nature";
import Payment from "./icons/Payment";
import People from "./icons/People";
import Person from "./icons/Person";
import PersonLined from "./icons/PersonLined";
import Plane from "./icons/Plane";
import PlaneSide from "./icons/PlaneSide";
import Popup from "./icons/Popup";
import RightArrow from "./icons/RightArrow";
import Road from "./icons/Road";
import School from "./icons/School";
import Store from "./icons/Store";
import Train from "./icons/Train";
import Warning from "./icons/Warning";
import chroma from "chroma-js";
import dynamic from "next/dynamic";
import { useColorsQuery } from "@graphql/api";

interface IconMap {
  [name: string]: ({
    className,
    color,
    secondaryColor,
  }: {
    className?: string;
    color: string;
    secondaryColor?: string;
  }) => JSX.Element;
}

const iconMapping: IconMap = {
  airport: Airport,
  arrowBoxDown: ArrowBoxDown,
  arrowDown: ArrowDown,
  arrowRight: ArrowRight,
  arrowRightDown: ArrowRightDown,
  attraction: Attraction,
  bag: Bag,
  bill: Bill,
  calendar: Calendar,
  checkmark: Checkmark,
  clock: Clock,
  clockLight: ClockLight,
  contact: Contact,
  cruise: Cruise,
  food: Food,
  globe: Globe,
  grid: Grid,
  health: Health,
  hotel: Hotel,
  house: House,
  info: Info,
  locationMarker: LocationMarker,
  nature: Nature,
  payment: Payment,
  people: People,
  person: Person,
  personLined: PersonLined,
  plane: Plane,
  planeSide: PlaneSide,
  popup: Popup,
  rightArrow: RightArrow,
  road: Road,
  school: School,
  store: Store,
  train: Train,
  warning: Warning,
};

function Icon({
  className = "",
  color = "",
  colorVar = "--primary-color",
  muted = false,
  secondaryColor = "",
  type,
}: {
  className?: string;
  color?: string;
  colorVar?: string;
  muted?: boolean;
  secondaryColor?: string;
  type: string;
}): JSX.Element | null {
  const { data } = useColorsQuery();
  const Component = iconMapping[type];

  let iconColor =
    color ||
    getComputedStyle(document.body).getPropertyValue(colorVar) ||
    "#bbb";
  const iconSecColor =
    secondaryColor ||
    getComputedStyle(document.body).getPropertyValue("--primary-text") ||
    "white";
  if (muted) iconColor = chroma(iconColor).alpha(0.75).hex();

  return data ? (
    <Component
      className={className}
      color={iconColor}
      secondaryColor={iconSecColor}
    />
  ) : null;
}

export default dynamic(() => Promise.resolve(Icon), {
  ssr: false,
});
